import { combineReducers } from "redux";
import listaPedidosMiniHub from "./slices/listaPedidosMiniHub.slice";

const reducer = combineReducers({
  listaPedidosMiniHub,
});

export default reducer;
